module.exports = __webpack_public_path__ + "img/12a.dd5b41b5.jpg";